import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { changeLanguage } from '../../i18n';

export default function AuthLayout() {
  const { i18n } = useTranslation();
  
  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
  };
  
  return (
    <div className="min-h-screen bg-neutral-light flex flex-col">
      <header className="flex items-center justify-between p-4">
        <Link to="/" className="flex items-center gap-2">
          <img src="/proctm_logo_blue.png" alt="ProCTM" className="h-auto w-18" />
          {/* <span className="text-xl font-semibold text-primary">ProCTM</span> */}
        </Link>
        
        <Menu as="div" className="relative">
          <Menu.Button className="p-2 rounded-md hover:bg-white/50">
            <GlobeAltIcon className="w-5 h-5 text-gray-600" />
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 rtl:right-auto rtl:left-0 mt-2 w-32 bg-white rounded-lg shadow-lg border border-gray-100 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleLanguageChange('en')}
                    className={`w-full px-4 py-2 text-sm text-left rtl:text-right ${
                      active ? 'bg-gray-50' : ''
                    } ${i18n.language === 'en' ? 'text-primary font-medium' : ''}`}
                  >
                    English
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleLanguageChange('ar')}
                    className={`w-full px-4 py-2 text-sm text-left rtl:text-right ${
                      active ? 'bg-gray-50' : ''
                    } ${i18n.language === 'ar' ? 'text-primary font-medium' : ''}`}
                  >
                    العربية
                  </button>
                )}
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
      </header>
      
      <main className="flex-1 flex items-center justify-center p-4">
        <Outlet />
      </main>
      
      <footer className="p-4 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} ProCTM. All rights reserved.
      </footer>
    </div>
  );
}
